import * as THREE from "three";
import { CSS2DRenderer } from "three/examples/jsm/Addons.js";
import type Camera from "./Camera";
import Experience from "./Experience";
import type Sizes from "./utils/Sizes";

export default class Renderer {
  experience: Experience;
  canvas: HTMLElement;
  sizes: Sizes;
  scene: THREE.Scene;
  camera: Camera;
  instance: THREE.WebGLRenderer;
  cssRenderer: CSS2DRenderer;

  constructor() {
    this.experience = new Experience();
    this.canvas = this.experience.canvas;
    this.sizes = this.experience.sizes;
    this.scene = this.experience.scene;
    this.camera = this.experience.camera;
    this.cssRenderer = new CSS2DRenderer();

    this.cssRenderer.domElement.style.position = "fixed"; // Fixed to bypass stacking contexts
    this.cssRenderer.domElement.style.top = "0px";
    this.cssRenderer.domElement.style.left = "0px";
    this.cssRenderer.domElement.style.pointerEvents = "none";
    this.cssRenderer.domElement.style.zIndex = "10"; // Above sections

    document.body.appendChild(this.cssRenderer.domElement);

    // Append CSS2DRenderer to the same parent as the canvas
    // const canvasParent = this.canvas.parentElement;
    // if (canvasParent) {
    //   canvasParent.appendChild(this.cssRenderer.domElement);
    // }

    this.instance = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
      alpha: true,
    });
    this.setInstance();
  }

  setInstance() {
    this.instance.sortObjects = false;
    this.instance.outputColorSpace = THREE.SRGBColorSpace;
    this.instance.toneMapping = THREE.ACESFilmicToneMapping;
    this.instance.toneMappingExposure = 1.0;
    this.instance.shadowMap.enabled = true;
    this.instance.shadowMap.type = THREE.PCFSoftShadowMap;
    this.instance.setClearColor("#211d20");
    this.resize();
  }

  resize() {
    this.instance.setSize(this.sizes.width, this.sizes.height);
    this.instance.setPixelRatio(this.sizes.pixelRatio);
    this.cssRenderer.setSize(this.sizes.width, this.sizes.height);
  }

  update() {
    this.instance.render(this.scene, this.camera.instance);
    this.cssRenderer.render(this.scene, this.camera.instance);
  }

  get height(): number {
    return this.instance.domElement.height;
  }

  get width(): number {
    return this.instance.domElement.width;
  }
}
